import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { AddMemberResponse, AddMemberParams } from './types';

export async function addOrganizationMember(organizationId: string, params: AddMemberParams) {
  const url = `/web/studio/organizations/${organizationId}/members`;

  /* eslint-disable camelcase */
  const body = {
    user_id: params.userId,
    role: params.role,
    title: params.title,
    has_permission_access_analytics: params.hasPermissionAccessAnalytics ?? false,
  };
  /* eslint-enable camelcase */

  const response = await api.executePostRequest<ObjectResponse<AddMemberResponse>>(url, body);

  return response.data;
}
